import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'
import NProgress from 'nprogress';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue')
    // component: Home
  },
  {
    path: '/agendar-servico',
    name: 'agendar-servico',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "agendar-servico" */ '../views/AgendarServico.vue')
  },
  {
    path: '/consultar-agendamento',
    name: 'consultar-agendamento',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "agendar-servico" */ '../views/ConsultarAgendamento.vue')
  },
  {
    path: '/listar-agendamento/:protocol/:cpf/:cellphone',
    name: 'listar-agendamento',
    props:true,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "agendar-servico" */ '../views/ListarAgendamento.vue')
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeResolve((to, from, next) => {
  // If this isn't an initial page load.
  if (to.name) {
      // Start the route progress bar.
      NProgress.start();
      NProgress.set(0.1)
  }
  next()
});

router.afterEach((to, from) => {
  // Complete the animation of the route progress bar.
  // NProgress.done()
  setTimeout(() => NProgress.done(), 500)
});

export default router
